// src/apiRoutes.js
// Configuración dinámica según el modo de ejecución
const isDevelopment = process.env.NODE_ENV !== 'production'

// Dev: Vite injecta les variables VITE_* des de .env.development (gitignorejat, una IP per dev).
// Prod: URL fixa compartida — el build de producció (vue-cli/webpack) no llegeix import.meta.env.
const API_BASE_URL = isDevelopment
  ? (import.meta.env?.VITE_API_BASE_URL || 'http://localhost:8000')
  : 'https://back.xperienceiq.es'

const WS_BASE_URL = isDevelopment
  ? (import.meta.env?.VITE_WS_BASE_URL || 'ws://localhost:8000')
  : 'wss://back.xperienceiq.es'

export const API_ROUTES = {
  LOGIN: `${API_BASE_URL}/token`,
  ME: `${API_BASE_URL}/usersconsola/me`,
  LOGOUT: `${API_BASE_URL}/logout`,

  // WebSocket endpoints
  WEBSOCKET: `${WS_BASE_URL}/ws`,

  // Usuaris
  USERS_CONSOLA: `${API_BASE_URL}/usersconsola`,
  USERS_WITH_CLIENTS: `${API_BASE_URL}/usersconsola/with-clients`,
  DELETE_USER_CONSOLA: (userId) => `${API_BASE_URL}/usersconsola/${userId}`,
  USER_CONSOLA: (userId) => `${API_BASE_URL}/usersconsola/${userId}`,

  // Profile endpoints
  UPDATE_MY_PROFILE: `${API_BASE_URL}/usersconsola/me/profile`,
  UPDATE_MY_AVATAR: `${API_BASE_URL}/usersconsola/me/avatar`,
  UPDATE_MY_PASSWORD: `${API_BASE_URL}/usersconsola/me/password`,

  // User config endpoints
  GET_USER_CONFIG: `${API_BASE_URL}/user-config/me`,
  UPDATE_USER_THEME: `${API_BASE_URL}/user-config/me/theme`,
  UPDATE_USER_LANGUAGE: `${API_BASE_URL}/user-config/me/language`,

  USER_PERMISSIONS: (userId) => `${API_BASE_URL}/users/${userId}/permissions`,
  ADD_USER_PERMISSION: (userId, permissionId) =>
    `${API_BASE_URL}/users/${userId}/permissions/${permissionId}`,
  REMOVE_USER_PERMISSION: (userId, permissionId) =>
    `${API_BASE_URL}/users/${userId}/permissions/${permissionId}`,
  ADD_USER_GROUP: (userId, groupId) =>
    `${API_BASE_URL}/users/${userId}/groups/${groupId}`,
  USER_GROUP: (userId) => `${API_BASE_URL}/users/${userId}/group`,
  UPDATE_USER_GROUP: (userId, groupId) =>
    `${API_BASE_URL}/users/${userId}/groups/${groupId}`,

  // Permisos
  PERMISOS: `${API_BASE_URL}/permisos/`,
  DELETE_PERMIS: (permisId) => `${API_BASE_URL}/permisos/${permisId}`,
  PERMIS: (permisId) => `${API_BASE_URL}/permisos/${permisId}`,
  GRUPS: `${API_BASE_URL}/grups/`,
  PERMISOS_GRUP: `${API_BASE_URL}/permisos/grup/`,
  CHECK_PERMISSION: (permission) =>
    `${API_BASE_URL}/check_permission?permission=${permission}`,

  CONFIG_CONSOLA: `${API_BASE_URL}/config_consola`,

  // New Config endpoints
  CONFIG_ALL: `${API_BASE_URL}/config`,
  CONFIG_BY_ID: (configId) => `${API_BASE_URL}/config/${configId}`,
  CONFIG_CREATE: `${API_BASE_URL}/config`,
  CONFIG_UPDATE: (configId) => `${API_BASE_URL}/config/${configId}`,
  CONFIG_DELETE: (configId) => `${API_BASE_URL}/config/${configId}`,

  DASHBOARD_CLIENT: `${API_BASE_URL}/dashboard/dashboard_client`,

  CLIENTS: `${API_BASE_URL}/clients`,
  CLIENTS_TE_HUB: `${API_BASE_URL}/clients/te-hub`,
  CLIENTS_CONNEXIONS: `${API_BASE_URL}/clients/connexions`,
  CLIENTS_HOLDED: `${API_BASE_URL}/clients/holded`,
  CLIENTS_HOLDED_PROPOSTA: (idHolded) => `${API_BASE_URL}/clients/holded/${idHolded}/proposta`,
  EJECUTAR_CONSULTES_UPDATE: (clientId) => `${API_BASE_URL}/ejecutar-consultas/${clientId}`,
  EJECUTAR_CONSULTES_DELETE: (clientId) => `${API_BASE_URL}/ejecutar-consultas/${clientId}`,
  EJECUTAR_CONSULTES_ARA: (clientId) => `${API_BASE_URL}/ejecutar-consultas/${clientId}/executar-ara`,

  // Monitorització i dimensionament del servei
  MONITORING_DIMENSIONAMENT: `${API_BASE_URL}/monitoring/dimensionament`,
  MONITORING_ACTUALITZACIONS: `${API_BASE_URL}/monitoring/actualitzacions`,
  MONITORING_ACTUALITZACIONS_EXECUTAR: (clientId) =>
    `${API_BASE_URL}/monitoring/actualitzacions/${clientId}/executar`,
  MONITORING_ACTUALITZACIONS_REINICIAR: (clientId) =>
    `${API_BASE_URL}/monitoring/actualitzacions/${clientId}/reiniciar`,

  // Versions de l'exe del XperienceHUB
  HUB_VERSIONS: `${API_BASE_URL}/hub/versions`,
  HUB_VERSION_ACTIVAR: (version) => `${API_BASE_URL}/hub/versions/${version}/activar`,
  HUB_VERSION_DELETE: (version) => `${API_BASE_URL}/hub/versions/${version}`,
  CLIENT_BY_ID: (clientId) => `${API_BASE_URL}/clients/${clientId}`,

  // New client users endpoints
  CLIENT_USERS: (clientId) => `${API_BASE_URL}/clients/${clientId}/users`,
  CLIENT_USER: (clientId, userId) => `${API_BASE_URL}/clients/${clientId}/users/${userId}`,

  // New endpoint to get client logo based on user ID
  USER_CLINIC_LOGO: (userId) => `${API_BASE_URL}/clients/${userId}/clinic-logo`,

  // New endpoint to get client info based on user ID
  USER_CLINIC_INFO: (userId) => `${API_BASE_URL}/clients/${userId}/clinic-info`,

  // Informes Seguiment - Grups
  INFORMES_GRUPS: `${API_BASE_URL}/informes-seguiment/grups`,
  INFORMES_GRUPS_CLIENT: (clientId) => `${API_BASE_URL}/informes-seguiment/grups-client/${clientId}`,
  INFORME_GRUP_BY_ID: (grupId) => `${API_BASE_URL}/informes-seguiment/grups/${grupId}`,
  INFORME_GRUP_CREATE: `${API_BASE_URL}/informes-seguiment/grups`,
  INFORME_GRUP_UPDATE: (grupId) => `${API_BASE_URL}/informes-seguiment/grups/${grupId}`,
  INFORME_GRUP_DELETE: (grupId) => `${API_BASE_URL}/informes-seguiment/grups/${grupId}`,

  // Informes Seguiment - Informes
  INFORMES: `${API_BASE_URL}/informes-seguiment/informes`,
  INFORME_BY_ID: (informeId) => `${API_BASE_URL}/informes-seguiment/informes/${informeId}`,
  INFORME_CREATE: `${API_BASE_URL}/informes-seguiment/informes`,
  INFORME_UPDATE: (informeId) => `${API_BASE_URL}/informes-seguiment/informes/${informeId}`,
  INFORME_DELETE: (informeId) => `${API_BASE_URL}/informes-seguiment/informes/${informeId}`,

  // Informes Seguiment - Comentarios
  COMENTARIS_INFORME: (informeId) => `${API_BASE_URL}/informes-seguiment/comentaris/${informeId}`,
  COMENTARI_CREATE: `${API_BASE_URL}/informes-seguiment/comentaris`,
  COMENTARI_UPDATE: (comentariId) => `${API_BASE_URL}/informes-seguiment/comentaris/${comentariId}`,
  COMENTARI_DELETE: (comentariId) => `${API_BASE_URL}/informes-seguiment/comentaris/${comentariId}`,

  // Informes Seguiment - Parámetros Cliente
  PARAMETRES_CLIENT: (clientId) => `${API_BASE_URL}/informes-seguiment/parametres/${clientId}`,
  PARAMETRE_TOGGLE: `${API_BASE_URL}/informes-seguiment/parametres`,
  PARAMETRES_BATCH: (clientId) => `${API_BASE_URL}/informes-seguiment/parametres/batch/${clientId}`,
  PARAMETRE_UPDATE: (clientId, informeId) => `${API_BASE_URL}/informes-seguiment/parametres/${clientId}/${informeId}`,
  PARAMETRE_DELETE: (parametreId) => `${API_BASE_URL}/informes-seguiment/parametres/${parametreId}`,

  // Informes Seguiment - Càlculs (DEPRECATED - usar CLIENT_CALCULS)
  CALCULS: `${API_BASE_URL}/informes-seguiment/calculs`,
  CALCULS_CLIENT: (clientId) => `${API_BASE_URL}/informes-seguiment/calculs?client_id=${clientId}`,
  CALCUL_CREATE: `${API_BASE_URL}/informes-seguiment/calculs`,
  CALCUL_UPDATE: (calculId) => `${API_BASE_URL}/informes-seguiment/calculs/${calculId}`,
  CALCUL_DELETE: (calculId) => `${API_BASE_URL}/informes-seguiment/calculs/${calculId}`,

  // Càlculs del Client (SQL Server)
  CLIENT_CALCULS_LIST: (clientId) => `${API_BASE_URL}/informes-seguiment/clientcalculs?client_id=${clientId}`,
  CLIENT_CALCULS_CREATE: (clientId) => `${API_BASE_URL}/informes-seguiment/clientcalculs?client_id=${clientId}`,
  CLIENT_CALCULS_UPDATE: (clientId, calculId) => `${API_BASE_URL}/informes-seguiment/clientcalculs/${calculId}?client_id=${clientId}`,
  CLIENT_CALCULS_DELETE: (clientId, calculId) => `${API_BASE_URL}/informes-seguiment/clientcalculs/${calculId}?client_id=${clientId}`,

  // Lookups del modal de càlcul (codis i tipus de tractament, del Gesden via HUB)
  LISTAR_TRACTAMENTS: (clientId) => `${API_BASE_URL}/informes-seguiment/tractaments?client_id=${clientId}`,
  LISTAR_TIPUS_TRACTAMENT: (clientId) => `${API_BASE_URL}/informes-seguiment/tipus-tractament?client_id=${clientId}`,

  // Consultas - Ejecución
  EXECUTE_QUERY: (token) => `${API_BASE_URL}/consultas/execute/${token}`
}
